module.exports = __webpack_public_path__ + "img/01logo1.4a688ac6.png";